import { combineReducers } from "redux";

import {
  LOGOUT,
  RECEIVE_CHARGES,
  RECEIVE_CONTRACT,
  RECEIVE_CONTRACT_FACILITY,
  RECEIVE_DEFAULT_FREQ_TYPES,
  RECEIVE_FACILITY,
  RECEIVE_GROUP,
  RECEIVE_LOGIN,
  RECEIVE_ORG_USER,
  RECEIVE_PREFERANCE,
  RECEIVE_REPORT_DATA,
  RECEIVE_REPORTING_TYPE,
  RECEIVE_STATUS,
} from "shared/actions/actions";
import { PERIODICAL_STATUS_REPORT_DATA, RECEIVE_DEFAULT_STATUS_TYPES, REPORT_PDF_DATA, REPORT_STATUS_TYPES } from "../actions/actions";

import { CHECK_FREQUENCY, CREATE_FREQUENCY, DELETE_FREQUENCY, GET_FREQUENCY, RECEIVE_FREQUENCY, UPDATE_FREQUENCY } from "shared/actions/frequency_action";
import {
  CHECK_PERIODICAL,
  CREATE_PERIODICAL,
  DELETE_PERIODICAL,
  RECEIVE_PERIODICAL_DETAILS,
  RECEIVE_PERIODICAL_REPORT,
  RECEIVE_PERIODICALS,
  UPDATE_PERIODICAL,
} from "shared/actions/periodicals_action";
import { SHOW_DOWNLOAD_BTN, SHOW_WARNING } from "../actions/periodicals_action";
import { STATUS_VIEW_DATA } from "../actions/statusView_action";
import allocationReducer from "./allocation_reducer";
import schedulingReducer from "./scheduling_reducer";

function postsBySubreddit(
  state = {
    group_items: [],
    facility_data: [],
    frequency_data: [],
    periodicals_data: [],
    periodical_delete_data: [],
    frequency_delete_data: [],
    frequency_data_by_id: [],
    frequency_create_response: [],
    status_list: [],
    charge_data: [],
    preferance_data: [],
    reporting_type_data: [],
    periodical_data: [],
    contract_data: [],
    contract_facility_data: [],
    occurence_data: [],
    login_user_data: [],
    org_user_list_data: [],
    schedule_periodicals_update: [],
    logout_data: [],
    check_frequency: [],
    check_periodical: [],
    occurence_status_data: [],
    status_view_data: [],
    report_response: [],
    periodical_report_data: [],
    showDownloadBtn: false,
    report_status_types: [],
    periodical_status_report_data: {},
    report_pdf_data: {},
    showWarning: false,
  },
  action
) {
  //console.log(state);
  switch (action.type) {
    case RECEIVE_GROUP:
      return Object.assign({}, state, {
        group_items: action.group_data,
      });

    case RECEIVE_FACILITY:
      return Object.assign({}, state, {
        facility_data: action.facility_data,
      });

    /* peridical master */

    case RECEIVE_PERIODICALS:
      return Object.assign({}, state, {
        periodicals_data: action.periodicals_data,
      });

    case DELETE_PERIODICAL:
      return Object.assign({}, state, {
        periodical_delete_data: action.periodical_delete_data,
      });

    case CREATE_PERIODICAL:
      return Object.assign({}, state, {
        periodical_delete_data: action.periodical_delete_data,
      });

    case RECEIVE_PERIODICAL_DETAILS:
      return Object.assign({}, state, {
        periodical_data: action.periodical_data,
      });

    case UPDATE_PERIODICAL:
      return Object.assign({}, state, {
        periodical_delete_data: action.periodical_delete_data,
      });

    case RECEIVE_PERIODICAL_REPORT:
      return Object.assign({}, state, {
        periodical_report_data: action.periodical_report_data,
      });
    case SHOW_DOWNLOAD_BTN:
      return Object.assign({}, state, {
        showDownloadBtn: action.showDownloadBtn,
      });
    case SHOW_WARNING:
      return Object.assign({}, state, {
        showWarning: action.showWarning,
      });

    /* peridical master end */

    /* frequency master start */
    case GET_FREQUENCY:
      return Object.assign({}, state, {
        frequency_data_by_id: action.frequency_data_by_id,
      });

    case CREATE_FREQUENCY:
      return Object.assign({}, state, {
        frequency_create_response: action.frequency_create_response,
      });

    case UPDATE_FREQUENCY:
      return Object.assign({}, state, {
        frequency_create_response: action.frequency_create_response,
      });

    case RECEIVE_FREQUENCY:
      return Object.assign({}, state, {
        frequency_data: action.frequency_data,
      });

    case DELETE_FREQUENCY:
      return Object.assign({}, state, {
        frequency_delete_data: action.frequency_delete_data,
      });

    /* frequency master end */

    case RECEIVE_STATUS:
      return Object.assign({}, state, {
        status_list: action.status_data,
      });

    case RECEIVE_CHARGES:
      return Object.assign({}, state, {
        charge_data: action.charge_data,
      });

    case RECEIVE_PREFERANCE:
      return Object.assign({}, state, {
        preferance_data: action.preferance_data,
      });

    case RECEIVE_REPORTING_TYPE:
      return Object.assign({}, state, {
        reporting_type_data: action.reporting_type_data,
      });

    case RECEIVE_CONTRACT:
      return Object.assign({}, state, {
        contract_data: action.contract_data,
      });

    case RECEIVE_CONTRACT_FACILITY:
      return Object.assign({}, state, {
        contract_facility_data: action.contract_facility_data,
      });

    case RECEIVE_DEFAULT_FREQ_TYPES:
      return Object.assign({}, state, {
        occurence_data: action.occurence_data,
      });

    case CHECK_FREQUENCY:
      return Object.assign({}, state, {
        check_frequency: action.check_frequency,
      });

    case CHECK_PERIODICAL:
      return Object.assign({}, state, {
        check_periodical: action.check_periodical,
      });

    /* login */
    case RECEIVE_LOGIN:
      return Object.assign({}, state, {
        login_user_data: action.login_user_data,
      });
    /*end */

    case LOGOUT:
      return Object.assign({}, state, {
        logout_data: action.logout_data,
      });

    case RECEIVE_ORG_USER:
      return Object.assign({}, state, {
        org_user_list_data: action.org_user_list_data,
      });

    case RECEIVE_DEFAULT_STATUS_TYPES:
      return Object.assign({}, state, {
        occurence_status_data: action.occurence_status_data,
      });

    case RECEIVE_REPORT_DATA:
      return Object.assign({}, state, {
        report_response: action.report_response,
      });

    // Status View

    case STATUS_VIEW_DATA:
      return Object.assign({}, state, {
        status_view_data: action.status_view_data,
      });

    case REPORT_STATUS_TYPES:
      return Object.assign({}, state, {
        report_status_types: action.report_status_types,
      });

    case REPORT_PDF_DATA:
      return Object.assign({}, state, {
        report_pdf_data: action.report_pdf_data,
      });

    case PERIODICAL_STATUS_REPORT_DATA:
      return Object.assign({}, state, {
        periodical_status_report_data: action.periodical_status_report_data,
      });

    default:
      return state;
  }
}

const rootReducer = combineReducers({
  postsBySubreddit,
  allocationReducer,
  schedulingReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/shared/reducers/reducers.js